import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import PlusThickIcon from 'mdi-react/PlusThickIcon';
import { withTranslation } from 'react-i18next';
import { checkKey, hasAccess } from "../../Services/SecurityService";
import { check, findAllLocalizacaoAcessosByDeleted, findAllByLocalizacaoAcessosEstado_localizacaoAcessos, findAllByLocalizacaoAcessosCidade_localizacaoAcessos } from "../../Services/LocalizacaoAcessosService";
import { findAllEstado } from "../../Services/EstadoService";
import { findAllCidade } from "../../Services/CidadeService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      hasAccess: false,
      selected: {},
      estados: [],
      localizacaoAcessosEstado: [],
      localizacaoAcessosCidade: [],
      data: []
    };
    check();
  }

  loadLocalizacaoAcessos(selected){
    findAllLocalizacaoAcessosByDeleted(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ data: data, selected });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadCidades(){
    findAllCidade()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadEstado(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(cidadeList){
    findAllEstado()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      let cidades = [];
      let estados = [];
      if(data !== undefined && data.error === undefined){
        estados = data;
        for(let i = 0; i < estados.length; i++){
          cidades = [];
          for(let j = 0; j < cidadeList.length; j++){
            if(estados[i].id === cidadeList[j].estado.id){
              cidades.push(cidadeList[j]);
            }
          }
          estados[i].cidades = cidades;
        }
        this.setState({ estados: data });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadLocalizacaoAcessosEstado(selected){
    findAllByLocalizacaoAcessosEstado_localizacaoAcessos(selected)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadLocalizacaoAcessosCidade(selected, data.localizacaoAcessosEstadoList);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadLocalizacaoAcessosCidade(selected, localizacaoAcessosEstado){
    findAllByLocalizacaoAcessosCidade_localizacaoAcessos(selected)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        if(selected.colorRGB !== null && selected.colorRGB !== undefined && selected.colorRGB !== ''){
          let rgb = JSON.parse(selected.colorRGB);
          selected.colorRGB = rgb;
        }
        this.setState({ selected, localizacaoAcessosEstado, localizacaoAcessosCidade: data.localizacaoAcessosCidadeList });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }


  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_LOCATION_ACCESS_VIEW")){
      this.loadLocalizacaoAcessos({});
      this.loadCidades();
      this.setState({ hasAccess: true });
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.loadLocalizacaoAcessosEstado(selected);
  }

  setSelectedNew = () => {
    this.setState({ selected: {id: 0} });
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadLocalizacaoAcessos(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;

    let view = '';
    let disabled = false;
    let notOK = !hasAccess("MENU_LOCATION_ACCESS_NEW");

    if(this.state.hasAccess){
      if(this.state.selected.id !== null && this.state.selected.id !== undefined){
        disabled = (this.state.selected.id === 0);
        view =  <CrudEdit 
                  selected = {this.state.selected} 
                  estados = {this.state.estados}
                  localizacaoAcessosEstado = {this.state.localizacaoAcessosEstado}
                  localizacaoAcessosCidade = {this.state.localizacaoAcessosCidade}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.localizacaoAcessos_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.localizacaoAcessos_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.setSelectedNew()}>
                <PlusThickIcon /> {t('forms.new')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);